import { useCallback, useMemo } from 'react';
import { useGetUserQuery } from '../../Api/attoDeskApi';
import { IUserInfo } from '../../Api/Interface/api.interface';

/**
 * useUser hook to manage user privileges
 * @returns { userHasRight, isLoading, isError }
 */
const useUser = () => {
  const { data, isLoading, isError } = useGetUserQuery();

  // Check if user has a specific privilege
  const userHasRight = useCallback(
    (privilege: string) => {
      if (isLoading || isError) {
        return false;
      }

      const privilegeData = data?.data as IUserInfo;

      if (!privilegeData || !Array.isArray(privilegeData.privileges)) {
        return false;
      }

      return privilegeData.privileges.includes(privilege);
    },
    [data, isLoading, isError]
  );

  return { userHasRight, isLoading, isError };
};

export default useUser;

// /**
//  * usePageQuery hook to set the url params and fetch from the url params
//  * @returns
//  */
// const useUser = () => {
//   const { data, isLoading, isError } = useGetUserQuery();
  
//   const userHasRight = useCallback(
//     (privilege: string) => {
//       if (isLoading || isError) {
//         return false;
//       }

//       // Ensure that data and data.data are not undefined before accessing 'privileges'
//       const privilegeData = data?.data as IUserInfo;

//       if (!privilegeData || !Array.isArray(privilegeData.privileges)) {
//         return false;
//       }

//       return privilegeData.privileges.includes(privilege);
//     },
//     [data, isError, isLoading] // Make sure data is included in dependencies
//   );
  
//   return { userHasRight };
// };

// export default useUser;

